import { render } from "./NewCuponForm.vue?vue&type=template&id=21e346f2&scoped=true"
import script from "./NewCuponForm.vue?vue&type=script&lang=js"
export * from "./NewCuponForm.vue?vue&type=script&lang=js"

import "./NewCuponForm.vue?vue&type=style&index=0&id=21e346f2&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-21e346f2"]])

export default __exports__